import { HttpClient } from '@pwc/pwc-deals-web-common';
import authorizationService from './security/authorizationService';
import userTokenService from './security/userTokenService';
import { createApiBaseQuery } from '../helpers/createApiBaseQuery';

type FixMeLater_PROJECT_ID = string | number;

export const safeErrors = (response?: { data?: { errors?: string[] } }) => {
  return response && response.data && response.data.errors
    ? response.data.errors
    : [];
};

export const UserAuthClient = new HttpClient(
  process.env.REACT_APP_USER_ACCESS_SERVICE,
  () => sessionStorage.getItem('jwtToken'),
  null
);

export const UserAuthRefreshClient = new HttpClient(
  process.env.REACT_APP_USER_ACCESS_SERVICE,
  () => sessionStorage.getItem('refreshToken'),
  null
);

export const UserAccessTokenClient = new HttpClient(
  process.env.REACT_APP_USER_ACCESS_SERVICE,
  null,
  null
);

export const ProjectManagementHttpClient = (
  projectId?: FixMeLater_PROJECT_ID
) =>
  new HttpClient(
    process.env.REACT_APP_PROJECT_MANAGEMENT_API_BASE_PATH,
    () => {
      authorizationService.updateProcessTime();
      return projectId
        ? userTokenService.getProjectToken(projectId)
        : sessionStorage.getItem('jwtToken');
    },
    null
  );

export const ProjectStateManagementHttpClient = (
  projectId?: FixMeLater_PROJECT_ID
) =>
  new HttpClient(
    process.env.REACT_APP_PROJECT_STATE_MANAGEMENT_API_BASE_PATH,
    () => {
      authorizationService.updateProcessTime();
      return projectId
        ? userTokenService.getProjectToken(projectId)
        : sessionStorage.getItem('jwtToken');
    },
    null
  );

export const getProjectTokenBasedOnPath = (path: string) => {
  const projectId = path.startsWith('/')
    ? path.split('/')[2]
    : path.split('/')[1];

  return userTokenService.getProjectToken(projectId);
};

export const getProjectTokenBasedOnPathFourth = (path: string) => {
  const projectId = path.startsWith('/')
    ? path.split('/')[4]
    : path.split('/')[3];
  return userTokenService.getProjectToken(projectId);
};

export const ProjectHttpClient = new HttpClient(
  process.env.REACT_APP_PROJECT_API_BASE_PATH,
  (path: string) => {
    authorizationService.updateProcessTime();
    return getProjectTokenBasedOnPath(path);
  },
  null
);

// TODO: remove REACT_APP_PROJECT_API_BASE_PATH after deploy new env variables
export const StructuredAnalysisHttpClient = new HttpClient(
  process.env.REACT_APP_STRUCTURED_ANALYSIS_SERVICE,
  (path: string) => {
    authorizationService.updateProcessTime();
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ProjectHttpClientV2 = new HttpClient(
  `${process.env.REACT_APP_PROJECT_API_BASE_PATH ?? ''}/v2/`,
  (path: string) => {
    authorizationService.updateProcessTime();
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ConnectedContentHttpClient = new HttpClient(
  process.env.REACT_APP_CONNECTED_CONTENT_API_BASE_PATH,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ConnectedContentServiceBaseQuery = createApiBaseQuery(
  ConnectedContentHttpClient
);

export const ContentServiceHttpClient = new HttpClient(
  process.env.REACT_APP_CONTENT_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ContentGroupServiceHttpClient = new HttpClient(
  process.env.REACT_APP_CONTENT_GROUP_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ContentServiceBaseQuery = createApiBaseQuery(
  ContentServiceHttpClient
);

export const KfaServiceHttpClient = new HttpClient(
  process.env.REACT_APP_KFA_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const POTopicServiceHttpClient = new HttpClient(
  process.env.REACT_APP_PO_TOPIC_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const KfaServiceBaseQuery = createApiBaseQuery(KfaServiceHttpClient);

export const ContentWorkflowServiceHttpClient = new HttpClient(
  process.env.REACT_APP_CONTENT_WORKFLOW_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ContentWorkflowServiceBaseQuery = createApiBaseQuery(
  ContentWorkflowServiceHttpClient
);

export const LibraryItemsExcelHttpClient = new HttpClient(
  process.env.REACT_APP_EXCEL_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const libraryItemsExcelHttpClientFetch = new HttpClient(
  process.env.REACT_APP_CLIPBOARD_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const LibraryItemsPptHttpClient = new HttpClient(
  process.env.REACT_APP_PPT_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const UserManagementHttpClient = new HttpClient(
  process.env.REACT_APP_USER_MANAGEMENT_API_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPathFourth(path);
  },
  null
);

export const LibraryItemsPowerBiHttpClient = new HttpClient(
  process.env.REACT_APP_POWERBI_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const TableauHttpClient = new HttpClient(
  process.env.REACT_APP_TABLEAU_API,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const LibraryItemsRichTextHttpClient = new HttpClient(
  process.env.REACT_APP_RICH_TEXT_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const LibraryItemsClipboardHttpClient = new HttpClient(
  process.env.REACT_APP_CLIPBOARD_LIBRARY_ITEM_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const ReportingApiClient = new HttpClient(
  process.env.REACT_APP_REPORTING_SERVICE,
  (path: string) => {
    authorizationService.updateProcessTime();
    return getProjectTokenBasedOnPath(path.replace('v2/', '/'));
  },
  null
);

export const CommentServiceClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_COMMENT_SERVICE,
    () => {
      authorizationService.updateProcessTime();
      return userTokenService.getProjectToken(projectId);
    },
    null
  );

export const CommentApiClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_COMMENT_API_BASE_PATH,
    () => {
      authorizationService.updateProcessTime();
      return userTokenService.getProjectToken(projectId);
    },
    null
  );

export const MasterApiClient = new HttpClient(
  process.env.REACT_APP_MASTER_API_BASE_PATH,
  () => sessionStorage.getItem('jwtToken'),
  null
);

export const SurveyServiceClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_SURVEY_SERVICE,
    () => {
      authorizationService.updateProcessTime();
      return userTokenService.getProjectToken(projectId);
    },
    null
  );

export const FileLibraryServiceClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_FILE_LIBRARY_SERVICE,
    () => {
      authorizationService.updateProcessTime();
      return userTokenService.getProjectToken(projectId);
    },
    null
  );

export const FileDownloadServiceClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_FILE_DOWNLOAD_SERVICE,
    () => {
      authorizationService.updateProcessTime();
      return userTokenService.getProjectToken(projectId);
    },
    null
  );

export const TagsServiceClient = new HttpClient(
  process.env.REACT_APP_TAGS_LIST_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const UserPreferencesProjectServiceHttpClient = new HttpClient(
  process.env.REACT_APP_USER_PREFERENCES_SERVICE,
  (path: string) => {
    return getProjectTokenBasedOnPath(path);
  },
  null
);

export const UserPreferencesServiceHttpClient = new HttpClient(
  process.env.REACT_APP_USER_PREFERENCES_SERVICE,
  () => sessionStorage.getItem('jwtToken'),
  null
);

export const LockHttpClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_LOCK_API_BASE_PATH,
    () => userTokenService.getProjectToken(projectId),
    null
  );

export const CreateFFAHttpClient = (projectId: FixMeLater_PROJECT_ID) =>
  new HttpClient(
    process.env.REACT_APP_CREATE_FFA_API_BASE_PATH,
    () => userTokenService.getProjectToken(projectId),
    null
  );
